export default __webpack_public_path__ + "static/media/pig_gray.f28cc290.svg";